import { render } from "./MappingFieldsForm.vue?vue&type=template&id=7a039a29&scoped=true&ts=true"
import script from "./MappingFieldsForm.vue?vue&type=script&lang=ts"
export * from "./MappingFieldsForm.vue?vue&type=script&lang=ts"

import "./MappingFieldsForm.vue?vue&type=style&index=0&id=7a039a29&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a039a29"],['__file',"src/app/catalog/mapping-template/inbound/mapping-template-manage/mapping-template-manage-form/MappingFieldsForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a039a29"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a039a29', __exports__)) {
    api.reload('7a039a29', __exports__)
  }
  
  module.hot.accept("./MappingFieldsForm.vue?vue&type=template&id=7a039a29&scoped=true&ts=true", () => {
    api.rerender('7a039a29', render)
  })

}


export default __exports__